import { createContext } from 'react';
import { IAction } from '../../shared-interfaces/Notation/IAction';
import { IMethodOfContact } from '../../shared-interfaces/Notation/IMethodOfContact';

interface ICustomWindow extends Window {
  initialAppState?: any;
}

interface INotationResponseAttributesContext {
  actions: IAction[];
  methodsOfContact: IMethodOfContact[];
}

const customWindow: ICustomWindow = window;

const NotationResponseAttributesContext = createContext(
  customWindow.initialAppState
    .notationResponseAttributes as INotationResponseAttributesContext,
);

export default NotationResponseAttributesContext;
